import {defaultContacts} from "./state";

export function setKardex(state, kardex) {
    state.kardex = kardex;
}
/**
 * Establecer un valor para la variable params.
 */
export function setParams(state, params) {
    state.params = params;
}



// WEBPACK FOOTER //
// ./src/modules/validate-kardex/mutations.js